import React, { useEffect, Fragment, useState } from "react";
import { endOfDay } from "date-fns";
import { Button, ButtonGroup, Grid } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import dashboardActions from "../../../redux/actions/dashboard";
import { DatePicker } from "@material-ui/pickers";
import { Link } from "react-router-dom";

export default function Dates() {
  const dashboard = useSelector((state) => state.dashboard);
  const app = useSelector((state) => state.app);

  const dispatch = useDispatch();

  const CURRENT = "CURRENT"
  const PREVIUS = "PREVIUS"
  const RANGE   = "RANGE"

  useEffect(() => {
    let dates = {
      dateInit: null,
      dateFinish: null,
    };
    const now = new Date();
    if (dashboard.dateRange === CURRENT) {
      dates = {
        dateInit: new Date(now.getFullYear(), now.getMonth(), 1),
        dateFinish: new Date(now.getFullYear(), now.getMonth() + 1, 1),
      };
      dispatch(dashboardActions.setDates(dates));
    }
    if (dashboard.dateRange === PREVIUS) {
      dates = {
        dateInit: new Date(now.getFullYear(), now.getMonth() - 1, 1),
        dateFinish: new Date(now.getFullYear(), now.getMonth(), 1),
      };
      dispatch(dashboardActions.setDates(dates));
    }
  }, [dashboard.dateRange]);

  const setDate = ({ date, type }) => {
    dispatch(
      dashboardActions.setDates({
        ...dashboard.dates,
        [type]: new Date(date),
        includeSearch: false
      })
    );
  };

  const searchDashboard = async (searchType) => {
    dispatch(dashboardActions.setDateRange(searchType))
  }

  return (
    <Fragment>
      <Grid container spacing={2} justify="flex-end">
        <Grid item>
          <ButtonGroup size="small" variant="contained">
            <Button
              onClick={() => {searchDashboard(RANGE)}}
              color={dashboard.dateRange === RANGE ? "primary" : "secondary"}
              disabled={app.loading}
            >
              seleccionar rango
            </Button>
            <Button
              onClick={() => {searchDashboard(PREVIUS)}}
              color={
                dashboard.dateRange === PREVIUS ? "primary" : "secondary"
              }
              disabled={app.loading}
            >
              mes anterior
            </Button>
            <Button
              onClick={() => {searchDashboard(CURRENT)}}
              color={
                dashboard.dateRange === CURRENT ? "primary" : "secondary"
              }
              disabled={app.loading}
            >
              mes actual
            </Button>
            <Button
              color="secondary"
              style={{ color: "#000" }}
              component={Link}
              to={"/admin/check-list"}
            >
              evaluaciones GIRA
            </Button>
          </ButtonGroup>
        </Grid>
      </Grid>
      {dashboard.dateRange === RANGE && (
        <Grid container spacing={2} justify="flex-end">
          <Grid item>
            <DatePicker
              inputVariant="outlined"
              margin="dense"
              label="Fecha inicial"
              value={dashboard.dates.dateInit}
              maxDate={dashboard.dates.dateFinish}
              disableFuture
              onChange={(date) => setDate({ date, type: "dateInit" })}
            />
          </Grid>
          <Grid item>
            <DatePicker
              inputVariant="outlined"
              margin="dense"
              label="Fecha final"
              value={dashboard.dates.dateFinish}
              minDate={dashboard.dates.dateInit}
              onChange={(date) =>
                setDate({
                  date: endOfDay(new Date(date)),
                  type: "dateFinish",
                })
              }
            />
          </Grid>
          <Grid item>
            <Button
              onClick={() => {dispatch(dashboardActions.fetchDataDashboard())}}
              color="primary"
              disabled={app.loading}
              style={{marginTop: "10px"}}
              variant="contained"
            >
              BUSCAR
            </Button>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
}
